import { Container, Typography } from "@mui/material";
import React from "react";
import AuthContainer from "../../../components/AuthContainer.js";
import appcolors from "../../../constants/Colors.js";
import ResetPasswordForm from "./ResetPasswordform.js";

const ResetPassword = () => {
  return (
    <AuthContainer>
      <Container sx={{ maxWidth: "520px !important", mt: 6 }}>
        <Typography variant="auth_h1" component={"h1"}>
          New Password{" "}
        </Typography>
        <Typography variant="auth_body1" component={"p"} sx={{ mt: 0.5 }}>
          Welcome to{" "}
          <span style={{ color: appcolors.black, fontWeight: "bold" }}>
            LOBA
          </span>{" "}
          CRM, Please enter your new password
        </Typography>
        <ResetPasswordForm />
      </Container>
    </AuthContainer>
  );
};

export default ResetPassword;
